import Link from "next/link";
import { useRouter } from "next/router";
import IntlMessages from "../Locale/IntlMessages";
import { GuideIco, ListLibIco } from "../Icons/IconMenu";
import { ROUTES } from "@/utils/pathRoutes";
import { useAuthStore } from "@/store/useAuthStore";

/**
 * TẠM HARD-CODE — revert: xóa block này và đổi `get children()` thành `children:`.
 * Server Admin chỉ hiện với các tài khoản dưới.
 */
const VAN_HOA_SERVER_ADMIN_EMAILS = new Set([
  "info@toppion.com.vn",
  "info@toppion.com.vn_demo",
]);

function canShowVanHoaServerAdmin() {
  const email = String(useAuthStore.getState().email ?? "").trim().toLowerCase();
  return VAN_HOA_SERVER_ADMIN_EMAILS.has(email);
}

/** Link tới báo cáo hiện tại–tương lai; lấy [id] từ route `/van-hoa/dot-danh-gia/bao-cao/[id]/hientaituonglai` khi đang trong flow đó. */
function BaoCaoSoSanhVanHoaNavLink() {
  const router = useRouter();
  const rawId = router.query.id;
  const idFromQuery = typeof rawId === "string" ? rawId : Array.isArray(rawId) ? rawId[0] : undefined;
  const idFromPath = router.asPath.match(/\/van-hoa\/dot-danh-gia\/bao-cao\/([^/]+)\//)?.[1];
  const id = idFromQuery ?? idFromPath;
  const href = id
    ? ROUTES.VAN_HOA.BAO_CAO_HIEN_TAI_TUONG_LAI(id)
    : ROUTES.VAN_HOA.BAO_CAO_HIEN_TAI_TUONG_LAI();

  return (
    <Link href={href}>
      <IntlMessages id="bsc.menu.bao-cao-so-sanh-van-hoa" text="Báo cáo so sánh" />
    </Link>
  );
}

export const CultureStep = {
  key: 'trien-khai-vh',
  label: <IntlMessages id="bsc.menu.trien-khai-vh" text="Triển Khai Văn Hóa" />,
  type: 'group' as const,
  get children() {
    const children = [
    {
      key: 'khao-sat-van-hoa',
      label: <IntlMessages id="bsc.menu.khao-sat-van-hoa" text="Khảo sát văn hóa" />,
      icon: (
        <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
          1
        </span>
      ),
      children: [
        {
          key: 'khao-sat-vh-hien-tai-tuong-lai',
          modulename: 'vanhoa_dotdanhgia_vanhoa,vanhoa_khaosatvanhoa,vanhoa_dotkhaosat,khaosatvanhoa.hientaituonglai,b1.khaosatvanhoa',
          checklicense: true,
          label: (
            <Link href="/van-hoa/dot-danh-gia/khao-sat-van-hoa-hien-tai-tuong-lai">
              <IntlMessages id="bsc.menu.khao-sat-vh-hien-tai-tuong-lai" text="Khảo sát văn hóa hiện tại tương lai" />
            </Link>
          ),
        },
        {
          key: 'bao-cao-so-sanh-van-hoa',
          modulename: 'vanhoa_dotdanhgia_dashboard,vanhoa_baocaoso,khaosatvanhoa.baocaososanh,b1.bao-cao-so-sanh-van-hoa',
          checklicense: true,
          label: <BaoCaoSoSanhVanHoaNavLink />,
        },
      ],
    },

    {
      key: 'xay-dung-nen-tang',
      label: <IntlMessages id="bsc.menu.xay-dung-nen-tang" text="Xây dựng nền tảng" />,
      icon: (
        <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
          2
        </span>
      ),
      children: [
        {
          key: 'loi-the-canh-tranh-cua-doanh-nghiep',
          modulename: 'vanhoa_danhgia,nentang.danhgia,b2.loithecanhtranh',
          checklicense: true,
          label: (
            <Link href="/van-hoa/danh-gia">
              <IntlMessages id="bsc.menu.loi-the-canh-tranh-cua-doanh-nghiep" text="Lợi thế cạnh tranh của doanh nghiệp" />
            </Link>
          ),
        },
        {
          key: 'ngoi-nha-van-hoa',
          modulename: 'vanhoa_ngoinha,vanhoa_ngoinhanvanhoa,nentang.ngoinha,b3.xaydungnentang',
          checklicense: true,
          label: (
            <Link href="/van-hoa/ngoi-nha">
              <IntlMessages id="bsc.menu.bao-cao-so-sanh-van-hoa" text="Ngôi nhà văn hóa" />
            </Link>
          ),
        },
        {
          key: 'hanh-vi-then-chot',
          modulename: 'vanhoa_hanhvithenchot,nentang.hanhvi,b2.hanhvithenchot',
          checklicense: true,
          label: (
            <Link href="/van-hoa/hanh-vi-then-chot">
              <IntlMessages id="bsc.menu.hanh-vi-then-chot" text="Hành vi then chốt" />
            </Link>
          ),
        },
        {
          key: 'an-le',
          modulename: 'vanhoa_anle,nentang.anle,b2.anle',
          checklicense: true,
          label: (
            <Link href="/van-hoa/an-le">
              <IntlMessages id="bsc.menu.hanh-vi-then-chot" text="Án lệ" />
            </Link>
          ),
        },
      ],
    },

    {
      key: 'bang-ke-hoach-group',
      label: <IntlMessages id="bsc.menu.bang-ke-hoach" text="Bảng kế hoạch" />,
      icon: (
        <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
          3
        </span>
      ),
      children: [
        {
          key: 'xuong-ca-ke-hoach',
          modulename: 'vanhoa_kehoachhanhdong,vanhoa_bangkehoach,vanhoa_xuongcakenhoach,bangkehoach.xuongca,b3.xuongcakenhoach',
          checklicense: true,
          label: (
            <Link href="/van-hoa/xuong-ca-ke-hoach">
              <IntlMessages id="bsc.menu.xuong-ca-ke-hoach" text="Xương cá" />
            </Link>
          ),
        },
        {
          key: 'bang-ke-hoach',
          modulename: 'vanhoa_kehoachhanhdong,vanhoa_bangkehoach,bangkehoach.bangkehoach,b3.bangkehoach',
          checklicense: true,
          label: (
            <Link href="/van-hoa/bang-ke-hoach">
              <IntlMessages id="bsc.menu.bang-ke-hoach" text="Bảng kế hoạch" />
            </Link>
          ),
        },
        {
          key: 'action-plan',
          modulename: 'vanhoa_kehoachhanhdong,vanhoa_actionplan,bangkehoach.actionplan,b3.actionplan',
          checklicense: true,
          label: (
            <Link href="/van-hoa/du-an">
              <IntlMessages id="bsc.menu.action-plan" text="Action Plan" />
            </Link>
          ),
        },
        {
          key: 'timeline',
          modulename: 'vanhoa_timeline_dashboard,vanhoa_timeline,bangkehoach.timeline,b3.timeline',
          checklicense: true,
          label: (
            <Link href="/van-hoa/timeline">
              <IntlMessages id="bsc.menu.timeline" text="Timeline" />
            </Link>
          ),
        },
      ],
    },

    {
      key: 'danh-gia-va-trai-nghiem',
      label: <IntlMessages id="bsc.menu.dnah-gia-va-trai-nghiem" text="Đánh giá sức khỏe doanh nghiệp và trải nghiệm nhân viên" />,
      icon: (
        <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
          4
        </span>
      ),
      children: [
        {
          key: 'danh-gia-suc-khoe-doanh-nghiep',
          modulename: 'vanhoa_danhgiadoanhnghiep,danhgia.truongthanhdoanhnghiep',
          checklicense: true,
          label: (
            <Link href="/van-hoa/dot-danh-gia/dot-khao-sat-truong-thanh-van-hoa">
              <IntlMessages id="bsc.menu.danh-gia-suc-khoe-doanh-nghiep" text="Đánh giá sức khỏe doanh nghiệp" />
            </Link>
          ),
        },
        {
          key: 'gan-ket-trai-nghiem-diem-cham-nhan-vien',
          modulename: 'vanhoa_tieuchigankettrainghiemdiemcham,danhgia.trainghiemnhanvien.tieuchi',
          checklicense: true,
          label: (
            <IntlMessages id="bsc.menu.gan-ket-trai-nghiem-diem-cham-nhan-vien" text="Gắn kết - Trải nghiệm - Điểm chạm nhân viên" />
          ),
          children: [
            {
              key: 'danh-sach-tieu-chi-gan-ket-trai-nghiem-diem-cham-nhan-vien',
              modulename: 'vanhoa_tieuchigankettrainghiemdiemcham,danhgia.trainghiemnhanvien.tieuchi',
              checklicense: true,
              label: (
                <Link href="/van-hoa/tieu-chi-nhan-vien/trai-nghiem-gan-ket-diem-cham">
                  <IntlMessages id="bsc.menu.danh-sach-tieu-chi-gan-ket-trai-nghiem-diem-cham-nhan-vien" text="Tiêu chí đánh giá" />
                </Link>
              ),
            },
            {
              key: 'dot-khao-sat-gan-ket-trai-nghiem-diem-cham-nhan-vien',
              modulename: 'vanhoa_dotkhaosatganket,danhgia.trainghiemnhanvien.khaosat',
              checklicense: true,
              label: (
                <Link href="/van-hoa/dot-danh-gia/dot-khao-sat-gan-ket-trai-nghiem-diem-cham-nhan-vien">
                  <IntlMessages id="bsc.menu.dot-khao-sat-gan-ket-trai-nghiem-diem-cham-nhan-vien" text="Khảo sát" />
                </Link>
              ),
            },
          ],
        },
      ],
    },
    
    // ================= Menu Admin Van Hoa =================
    {
      key: 'admin-van-hoa',
      label: <IntlMessages id="bsc.menu.server-van-hoa" text="Server Admin" />,
      icon: (
        <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
          5
        </span>
      ),
      children: [
        {
          key: 'admin-1',
          modulename: 'vanhoa_admincauhoi,server.cauhoihientaituonglai',
          checklicense: true,
          label: (
            <Link href="/van-hoa/admin/cau-hoi">
              <IntlMessages id="bsc.menu.admincauhoi" text="Admin câu hỏi hiện tại tương lai" />
            </Link>
          ),
        },
        {
          key: 'admin-2',
          modulename: 'vanhoa_admintieuchivanhoa,server.tieuchitruongthanhtrainghiem',
          checklicense: true,
          label: (
            <Link href="/van-hoa/admin/tieu-chi-van-hoa">
              <IntlMessages id="bsc.menu.admintieuchivanhoa" text="Admin tiêu chí trưởng thành và Trải nghiệm VH" />
            </Link>
          ),
        },
        {
          key: 'admin-3',
          modulename: 'vanhoa_admintieuchigankettrainghiemdiemcham,server.tieuchi',
          checklicense: true,
          label: (
            <Link href="/van-hoa/admin/tieu-chi-ganket-trainghiem-diemcham">
              <IntlMessages id="bsc.menu.admintieuchigankettrainghiemdiemcham" text="Admin tiêu chí gắn kết - Trưởng thành - Điểm chạm" />
            </Link>
          ),
        },
        {
          key: 'admin-4',
          modulename: 'vanhoa_adminkehoachhanhdong,server.danhsachkehoach',
          checklicense: true,
          label: (
            <Link href="/van-hoa/admin/ke-hoach-hanh-dong">
              <IntlMessages id="bsc.menu.adminkehoachhanhdong" text="Admin Danh sách kế hoạch" />
            </Link>
          ),
        },
        {
          key: 'admin-5',
          modulename: 'vanhoa_admincauhoianle,server.cauhoianle',
          checklicense: true,
          label: (
            <Link href="/van-hoa/admin/cau-hoi-an-le">
              <IntlMessages id="bsc.menu.admincauhoianle" text="Admin câu hỏi án lệ" />
            </Link>
          ),
        },
        {
          key: 'admin-6',
          modulename: 'vanhoa_admintieuchi,server.tieuchi',
          checklicense: true,
          label: (
            <Link href="/van-hoa/admin/tieu-chi">
              <IntlMessages id="bsc.menu.admintieuchi" text="Admin tiêu chí" />
            </Link>
          ),
        },
      ],
    },
  ];
    return canShowVanHoaServerAdmin()
      ? children
      : children.filter((item) => item.key !== 'admin-van-hoa');
  },
}

export const LibraryStep = {
  key: 'thu-vien-van-hoa',
  label: <IntlMessages id="bsc.menu.thu-vien-van-hoa" text="Thư viện" />,
  type: 'group' as const,
  children: [
    {
      key: 'khao-sat-danh-gia',
      label: <IntlMessages id="bsc.menu.danh-gia-khao-sat" text="Khảo sát đánh giá" />,
      icon: (
        <span>
          <ListLibIco />
        </span>
      ),
      children: [
        {
          key: 'khao-sat-van-hoa-hien-tai-tuong-lai',
          modulename: 'vanhoa_dotdanhgia_vanhoa,vanhoa_khaosatvanhoa,vanhoa_dotkhaosat,khaosatvanhoa.hientaituonglai,b1.khaosatvanhoa',
          checklicense: true,
          label: (
            <Link href="/van-hoa/dot-danh-gia/khao-sat-van-hoa-hien-tai-tuong-lai">
              <IntlMessages id="bsc.menu.khao-sat-vh-hien-tai-tuong-lai" text="Khảo sát văn hóa hiện tại tương lai" />
            </Link>
          ),
        },
        {
          key: 'khao-sat-muc-do-hieu-va-nho-van-hoa',
          modulename: 'vanhoa_khaosatmucdohieunhovanhoa,danhgia.hieuvanhovanhoa.khaosat',
          checklicense: true,
          label: (
            <Link href="/van-hoa/dot-danh-gia/dot-khao-sat-van-hoa">
              <IntlMessages id="bsc.menu.khao-sat-muc-do-hieu-va-nho-van-hoa" text="Khảo sát mức độ hiểu và nhớ văn hoá" />
            </Link>
          ),
        },
        {
          key: 'danh-gia-hinh-mau',
          modulename: 'vanhoa_hinhmau_danhgia,danhgia.lanhdao,danhgia.kethua,danhgia.bophan',
          checklicense: true,
          label: (
            <Link href="/van-hoa/hinh-mau/danh-gia">
              <IntlMessages id="bsc.menu.danh-gia-hinh-mau" text="Đánh giá hình mẫu" />
            </Link>
          ),
        },
        {
          key: 'dot-danh-gia-suc-khoe-doanh-nghiep',
          modulename: 'vanhoa_danhgiadoanhnghiep,danhgia.truongthanhdoanhnghiep',
          checklicense: true,
          label: (
            <Link href="/van-hoa/dot-danh-gia/dot-khao-sat-truong-thanh-van-hoa">
              <IntlMessages id="bsc.menu.dot-danh-gia-suc-khoe-doanh-nghiep" text="Đánh giá sức khoẻ doanh nghiệp" />
            </Link>
          ),
        },
        {
          key: 'khao-sat-danh-gia-dot-khao-sat-gan-ket-trai-nghiem-diem-cham-nhan-vien',
          modulename: 'vanhoa_dotkhaosatganket,danhgia.trainghiemnhanvien.khaosat',
          checklicense: true,
          label: (
            <Link href="/van-hoa/dot-danh-gia/dot-khao-sat-gan-ket-trai-nghiem-diem-cham-nhan-vien">
              <IntlMessages id="bsc.menu.khao-sat-gan-ket" text="Khảo sát gắn kết - trải nghiệm - điểm chạm nhân viên" />
            </Link>
          ),
        },
      ],
    },

    {
      key: 'tieuchi-tinh-huong-bo-cau-hoi',
      label: <IntlMessages id="bsc.menu.tieuchi-bo-cau-hoi" text="Tiêu chí, bộ câu hỏi" />,
      icon: (
        <span>
          <GuideIco />
        </span>
      ),
      children: [
        {
          key: 'tieu-chi-hinh-mau',
          modulename: 'vanhoa_hinhmau_tieuchi,bocauhoi.tieuchilanhdao,bocauhoi.tiuchikethua,bocauhoi.tieuchibophan',
          checklicense: true,
          label: (
            <Link href="/van-hoa/hinh-mau/tieu-chi/lanh-dao">
              <IntlMessages id="bsc.menu.tieuchi-bo-cau-hoi" text="Bộ tiêu chí hình mẫu" />
            </Link>
          ),
        },
        {
          key: 'cau-hoi-an-le',
          modulename: 'vanhoa_cauhoianle,bocauhoi.cauhoianle',
          checklicense: true,
          label: (
            <Link href="/van-hoa/cau-hoi-an-le">
              <IntlMessages id="bsc.menu.cau-hoi-an-le" text="Bộ câu hỏi văn hoá" />
            </Link>
          ),
        },
      ],
    }
  ],
}